module.exports = __webpack_public_path__ + "assets/img/icon_action_delete.0a24344e.svg";